<app-payroll-management-tabs></app-payroll-management-tabs>

<div class="card">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-12">
        <h2 class="mb-1">Reimbursement Approval</h2>
        <p class="text-muted">Review receipts, choose the approved amount, and assign approved requests to payroll.</p>
        <p class="text-muted mb-0">{{ isHRApprover
          ? 'HR approval completes the request and sends it to payroll.'
          : 'AA approval sends eligible requests to HR for final approval.' }}</p>
      </div>
      <div class="form-group col-12 col-md-3">
        <label for="reimbursementStatusFilter">Status</label>
        <select id="reimbursementStatusFilter" class="form-control" [(ngModel)]="filters.statusID">
          <option [ngValue]="null">All</option>
          <option [ngValue]="reimbursementStatus.Pending">Pending</option>
          <option [ngValue]="reimbursementStatus.AAApprovedPendingHRApproval">AA Approved - Pending HR Approval</option>
          <option [ngValue]="reimbursementStatus.Approved">Approved</option>
          <option [ngValue]="reimbursementStatus.Denied">Denied</option>
        </select>
      </div>
      <div class="form-group col-12 col-md-3">
        <label for="reimbursementTypeFilter">Reimbursement Type</label>
        <select id="reimbursementTypeFilter" class="form-control" [(ngModel)]="filters.reimbursementTypeID">
          <option [ngValue]="null">All available types</option>
          <option *ngFor="let type of reimbursementTypes" [ngValue]="type.id">{{ type.name }}</option>
        </select>
      </div>
      <div class="form-group col-12 col-md-3">
        <label for="reimbursementEmployeeFilter">Employee</label>
        <input id="reimbursementEmployeeFilter" type="text" class="form-control" [(ngModel)]="filters.employee">
      </div>
      <div class="form-group col-12 col-md-3">
        <label for="reimbursementCampusFilter">Region / Campus</label>
        <select id="reimbursementCampusFilter" class="form-control" [(ngModel)]="filters.campusID">
          <option [ngValue]="null">All available regions / campuses</option>
          <option *ngFor="let campus of campuses" [ngValue]="campus.id">{{ campus.programName }}</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-3">
        <label for="reimbursementMinimumAmountFilter">Minimum Amount</label>
        <input id="reimbursementMinimumAmountFilter" type="number" min="0" step="0.01" class="form-control"
               [(ngModel)]="filters.minimumAmount">
      </div>
      <div class="form-group col-6 col-md-3">
        <label for="reimbursementMaximumAmountFilter">Maximum Amount</label>
        <input id="reimbursementMaximumAmountFilter" type="number" min="0" step="0.01" class="form-control"
               [(ngModel)]="filters.maximumAmount">
      </div>
      <div class="form-group col-6 col-md-3">
        <label for="reimbursementSubmittedFromFilter">Submitted From</label>
        <input id="reimbursementSubmittedFromFilter" type="date" class="form-control" [(ngModel)]="filters.submittedFrom">
      </div>
      <div class="form-group col-6 col-md-3">
        <label for="reimbursementSubmittedThroughFilter">Submitted Through</label>
        <input id="reimbursementSubmittedThroughFilter" type="date" class="form-control" [(ngModel)]="filters.submittedThrough">
      </div>
      <div class="form-group col-12 col-md-3">
        <label for="reimbursementPayrollPeriodFilter">Payroll Date</label>
        <select id="reimbursementPayrollPeriodFilter" class="form-control" [(ngModel)]="filters.payPeriodID">
          <option [ngValue]="null">All payroll dates</option>
          <option *ngFor="let period of payPeriods" [ngValue]="period.payPeriodID">{{ period.payPeriod }}</option>
        </select>
      </div>
      <div class="col-12 d-flex justify-content-end">
        <button id="clearReimbursementFilters" type="button" class="btn btn-link" (click)="clearFilters()">Clear</button>
        <button id="applyReimbursementFilters" type="button" class="btn btn-primary" (click)="loadReimbursements()">Apply Filters</button>
      </div>
    </div>

    <i *ngIf="loading" class="material-icons rotate text-muted">loop</i>
    <div *ngIf="!loading && !reimbursements.length" class="alert alert-info">No reimbursement requests match these filters.</div>

    <div *ngIf="!loading && reimbursements.length" class="table-responsive">
      <table class="table table-striped reimbursement-approval-table">
        <thead>
          <tr>
            <th>Employee / Expense</th>
            <th>Request</th>
            <th>Receipt</th>
            <th>Approval</th>
            <th>Decision</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reimbursement of reimbursements" [attr.data-reimbursement-id]="reimbursement.id">
            <td>
              <strong>{{ reimbursement.employeeName }}</strong><br>
              <span *ngIf="reimbursement.campusName" class="text-muted">{{ reimbursement.campusName }}</span><br *ngIf="reimbursement.campusName">
              {{ reimbursement.expenseDate | date:'MM/dd/yyyy' }} - {{ reimbursement.merchant }}<br>
              <span class="text-muted">{{ reimbursement.description }}</span>
            </td>
            <td>
              {{ reimbursement.reimbursementType }}<br>
              <strong>{{ reimbursement.requestedAmount | currency }}</strong><br>
              <span class="badge badge-secondary">{{ reimbursement.status }}</span>
            </td>
            <td>
              <button type="button" class="btn btn-link p-0" (click)="downloadReceipt(reimbursement)">
                {{ reimbursement.receiptFileName }}
              </button>
            </td>
            <td>
              <ng-container *ngIf="canAct(reimbursement); else decisionDetails">
                <label [for]="'approvedAmount' + reimbursement.id">Approved Amount</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend"><span class="input-group-text">$</span></div>
                  <input [id]="'approvedAmount' + reimbursement.id" type="number" min="0.01" max="1000000" step="0.01"
                         class="form-control" [(ngModel)]="approvedAmounts[reimbursement.id]">
                </div>
                <label [for]="'payPeriod' + reimbursement.id">Payroll Period</label>
                <select [id]="'payPeriod' + reimbursement.id" class="form-control" [(ngModel)]="selectedPayPeriods[reimbursement.id]">
                  <option [ngValue]="null">Select a period...</option>
                  <option *ngFor="let period of payPeriods" [ngValue]="period.payPeriodID">{{ period.payPeriod }}</option>
                </select>
              </ng-container>
              <ng-template #decisionDetails>
                <span *ngIf="reimbursement.approvedAmount != null">Approved: {{ reimbursement.approvedAmount | currency }}</span><br>
                <span *ngIf="reimbursement.payPeriodStartDate">Payroll: {{ reimbursement.payPeriodStartDate | date:'MM/dd/yyyy' }} - {{ reimbursement.payPeriodEndDate | date:'MM/dd/yyyy' }}</span>
                <span *ngIf="reimbursement.denialReason" class="text-danger">{{ reimbursement.denialReason }}</span>
              </ng-template>
            </td>
            <td>
              <ng-container *ngIf="canAct(reimbursement)">
                <button [id]="'approveReimbursement' + reimbursement.id" type="button" class="btn btn-success btn-block mb-2"
                        [disabled]="processingID === reimbursement.id" (click)="approve(reimbursement)">
                  {{ isHRApprover ? 'Approve' : 'AA Approve' }}
                </button>
                <label [for]="'denialReason' + reimbursement.id">Denial Reason</label>
                <textarea [id]="'denialReason' + reimbursement.id" class="form-control mb-2" rows="2" maxlength="1000"
                          [(ngModel)]="denialReasons[reimbursement.id]"></textarea>
                <button [id]="'denyReimbursement' + reimbursement.id" type="button" class="btn btn-outline-danger btn-block"
                        [disabled]="processingID === reimbursement.id" (click)="deny(reimbursement)">Deny</button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
